import { render, staticRenderFns } from "./TrainingLearningContentTiles.vue?vue&type=template&id=b56bd8a8"
import script from "./TrainingLearningContentTiles.vue?vue&type=script&lang=js"
export * from "./TrainingLearningContentTiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports